import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { Post, PostField, Template } from '../container';
import { FirestoreService } from '../firestore-service.service';
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { SharedServiceService } from '../shared-service.service';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import { ConfirmingDialogComponent } from '../confirming-dialog/confirming-dialog.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UploadpopupComponent } from '../uploadpopup/uploadpopup.component';
import { AddworkpackagedialogComponent } from '../addworkpackagedialog/addworkpackagedialog.component';
import { SearchService } from '../search.service';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SharedModule } from '../shared/shared.module';
import { IntersiteModule } from '../shared/intersite.module';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import '@googleworkspace/drive-picker-element';
import { DetailsforpageComponent } from '../detailsforpage/detailsforpage.component';
import { OgragService } from '../ograg.service';
import { ProofstatementComponent } from '../proofstatement/proofstatement.component';


declare const google: any;
declare const gapi: any;

@Component({
  selector: 'app-contentlist',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    PdfViewerModule,
    SharedModule,
    IntersiteModule,
    HttpClientModule,
    DetailsforpageComponent,
    ConfirmingDialogComponent,
    ProofstatementComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './contentlist.component.html',
  styleUrl: './contentlist.component.scss'
})
export class ContentlistComponent {
  @Input() organizationKey: string = ""
  @Input() projectKey: string = ""
  @Input() projectName: string = ""
  @Input() templates: Template[] = []
  @Input() teamKey: string = ""
  @Input() teamName: string = ""
  @Input() userId: string = ""
  @Input() selectedTeamKey: string = ""
  @Input() site: string = ""
  @Input() teams: any[] = []
  @Input() hideMenus: boolean = false
  @Input() skippedContentKeys: string[] = []
  @Input() skippedContentTypes: string[] = []
  @Input() contextMessage: string = ""
  @Input() showCloseButton: boolean = false
  @Input() donotShow: boolean = false
  @Input() filter: string = ""
  @Input() isAnonymous: boolean = true
  @Output() onSelectedPostKey = new EventEmitter<string>()
  @Output() onSelectedContent = new EventEmitter<Post[]>()
  @Output() closeContentList = new EventEmitter<Post[]>()
  @Output() loaderMessageEmitter = new EventEmitter<string>()
  @Output() isLoadingLabelVisibleEmitter = new EventEmitter<boolean>()
  loaderMessage = "Project data is loaded, please wait..."
  isLoadingLabelVisible = true; // used for showing loader popup
  personas: {"name": string, "key": string, "description": string}[] = []
  posts: Post[] = []
  postsBeforeFiltering: Post[] = [] // array of all posts before filtering, used to recover posts when filtering is cleared without reloading
  isListening = true
  loggeduserEmail: string = "";
  loggeduserPhotoURL: string = "";
  userDisplayName: string = "";
  imageURLs: string[] = [];
  truncateclass = "truncate-small";
  maxFileSize = 10000000 // 10MB in bytes allowed for file upload
  
  selectedProject = ""
  newPost: Post = {"authorKey": "", "authorName": "", "categoryKey": "", "commentCount": 0, "nameHTML": "", "contentRowsCount": 0, "dateOfCreation": new Date(), "dateOfUpdate": new Date(), "formattedDate": "", "imageURLs": [], "coverImageURL": "", "key": "", "lastCommentDate": new Date(), "organizationKey": "", "name": "", "projectKey": "", "title": "", "viewCount": 0, "isNewPost": true, "isDeleted": false, "loggedUserDisplayName": "", "loggedUserKey": "", "isDownloadAvailable": false, "projectName": "", "templateKey": "", "color": "", "fields": [], "tags": [], "contentType": "", "embedding": [], "isRead": false, "isTop": false, "isFavourite": false, "progressPercent": 0, "startDate": new Date(), "endDate": new Date(), "manHours": 0, "isSelected": false, "templateName": "", "areKidsColored": false, "areKidsTagged": false, "isCompleted": false, "parentName": "", "isParent": false, "assignedUsers": [], "status": "", "sequence": 0, "parentKey": "", "isExpanded": false, "milestoneKey": "", "isChecked": false, "description": "", "fileType": ""}
  projects: {"key": string, "name": string, "count": number}[] = []
  stopList: string[] = []
  searchResult: string[] = [] // keys of posts found
  queryTokensChecked: number = 1
  searchQuery: string = ""
  channelKey: string = "" // key of  discussion channel
  commentCount: number = 0
  fieldKeyWithLinks = -1
  now = new Date()
  channelName = ""
  channelPath = ""
  projectIsDeleted = false
  menuItems: {key: string, name: string, color: string, count: number}[] = []
  unsubscribePosts: any
  unsubscribeDocuments: any
  isCollapsed = false
  postsSortedBy = "date"
  postsSortedByAscending = true
  tutorialTooltips: {"object": string, "tooltipSelector": string, "tooltipCaption": string}[] = [
    {"object": "#kanban", "tooltipSelector": "#tooltip", "tooltipCaption": "Here you can see kanban board of your project."},
    {"object": "#discussion", "tooltipSelector": "#tooltip", "tooltipCaption": "Here you can read comments associated with your project, knowledge pieces, and tasks."},
    {"object": "#addnotebutton", "tooltipSelector": "#tooltip", "tooltipCaption": "Click this button to add new note to organization knowledge base."},
    {"object": "#notedetails", "tooltipSelector": "#tooltip", "tooltipCaption": "Tap this sample note to see details and edit it."},
    {"object": "#searchinput", "tooltipSelector": "#tooltip", "tooltipCaption": "You can search your knowledge base by typing keywords or whole sentences."},
    {"object": "#changeorg", "tooltipSelector": "#tooltip", "tooltipCaption": "Organization is a container for projects, knowledge base and staff. You can switch between them here."},
    {"object": "#changeprj", "tooltipSelector": "#tooltip", "tooltipCaption": "You can have multiple projects and you can switch between them here."}
  ]
  tutorialTooltipMessage = ""
  isChatVisible = false
  userImageURL = ""
  isReadOnly = false
  visiblePosts = 16
  postVisibleIncrement = 16
  showFavouriteOnly = false
  postsLoaded = false
  embeddingModel = "gemini-embedding-001"
  scrollPosition = 0
  newPostName = ""
  isMenuExpanded = true
  isColorPalleteVisible = false
  showTagsPopup = false
  tags: {tag: string, isSelected: boolean}[] = []
  shownTemplates: string[] = [] // array of keys of templates that are shown in feed for filtering
  private scrollListener: EventListenerOrEventListenerObject | null = null;
  colors: string[] = []
  color = "#ffffff"
  newPostKey = ""
  showTutorialPopup = false
  selectedContentKeys: string[] = [] // array of posts that are selected by user
  showFileDropPopup = false
  pdfSrc: any
  showPDFPreview = false
  dropFilesMessage = "Drop files here to upload them to the project."
  selectedTeamName = ""
  filterByTeam = false
  selectedPostKey = ""
  itemIndexContextMenu = -1
  selectedPostTemplateKey = ""
  selectedPost = {} as Post
  selectedTemplateKey = ""
  areAllPostsSelected = false
  isAddPostMenuVisible = false
  isFilterPopupVisible = false
  activeFilters: {content: string, displayName: string}[] = []
  shownPersonas: string[] = [] // array of keys of personas that are shown in feed for filtering
  dialogRef: any
  menuX: number = 0; // position of context menu
  menuY: number = 0; // position of context menu
  isPostPanelOpen = false
  post = {} as Post
  templateKey = ""
  type = ""
  manHours = 0
  progressPercent = 0
  isNewPost = false
  captureImage = false
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.XSmall);
  startDate = ""
  endDate = ""
  isSelected = false
  isTop = false
  isFavourite = false
  templateName = ""
  isRead = false
  isDeleted = false
  areKidsTagged = false
  areKidsColored = false
  isCompleted = false
  columnKey = ""
  organizationStorage = 0
  maxOrganizationStorage = 100000000 // 100MB in bytes
  showOneProjectOnly = true
  private googleClientLoadingPromise: Promise<void> | null = null;
  private googleClientLoaded = false;
  token = ""
  isContentListVisible = true

  constructor(private breakpointObserver: BreakpointObserver, private firestore: FirestoreService, private service: SharedServiceService, private router: Router, public dialog: MatDialog, private search: SearchService, private http: HttpClient, private ograg: OgragService) {
    this.loaderMessageEmitter.emit("Project data is loaded, please wait...")
  }

  ngOnInit() {
    // Load the Google Identity Services script before initializing the token client
   // this.initGoogleAuthClient()
   this.search.getIdToken().then(token => {
    this.token = token
   })
  }

  ngAfterViewInit() {
    this.initiateFeed()
    this.getPersonas()

    setTimeout(() => { // this must be delayed to avoid the issue that templates are not loaded yet
      this.templates = this.templates.filter(t => t.type == "post")
      this.templates.push({"name": "Document", "color": "#ffffff", "key": "document", "fields": [], "type": "document", "explanation": "", "kidTemplates": [], "title": "", "subtitle": ""})
      this.templates.unshift({"name": "Tree", "color": "#ffffff", "key": "canvas", "fields": [], "type": "canvas", "explanation": "", "kidTemplates": [], "title": "", "subtitle": ""})
    }, 1000)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['organizationKey'] || changes['projectKey']) {
      const projectKey = changes['projectKey'].currentValue

      this.updateProject(projectKey)
    }
    if (changes['hideMenus']) {
      const hideMenus = changes['hideMenus'].currentValue || false
      if (hideMenus == true) {
        this.closePostPanel()
      }
    }
  }

  async initiateFeed() {
    this.organizationStorage = await this.firestore.getOrganizationStorage(this.organizationKey)

      this.showTagsPopup = false
      if (this.service.currentOrganizationKey != this.organizationKey && this.organizationKey != undefined) {
        this.service.changeOrganization(this.organizationKey)
      }
   // await this.updateProject("")
  }

  ngOnDestroy() {
    if (this.unsubscribePosts) {
      this.unsubscribePosts()
    }
    if (this.unsubscribeDocuments) {
      this.unsubscribeDocuments()
    }
    if (this.scrollListener) {
      window.removeEventListener('scroll', this.scrollListener);
      this.scrollListener = null; // Clean up reference
    }
  }

  async getProjects() {
    return await this.firestore.getProjectsByOrganizationUser(this.organizationKey, this.userId).then(projects => {
      return projects.map(project => ({key: project.key, name: project.name, count: 0}))
    })
  }

  async startListening(projectKey: string, projectName: string, teamKey: string, filterByTeam: boolean = false, filterByProject: boolean = false) { // starts observing content collection
    const app = this.firestore.getApps()
    this.projects = await this.getProjects()
    this.tags.length = 0
    this.postsLoaded = false
    let pLoaded = false
    let dLoaded = false
    let postQuery = query(collection(app, "organizations", this.organizationKey, "content"), where("type", "==", "post"), where("isDeleted", "==", false), orderBy("dateOfUpdate", "desc"));
    let documentQuery = query(collection(app, "organizations", this.organizationKey, "documents"), orderBy("dateOfUpdate", "desc"));
    if (filterByProject == true) {
      postQuery = query(postQuery, where("projectKey", "==", projectKey))
      documentQuery = query(documentQuery, where("projectKey", "==", projectKey))
    } else if (filterByTeam == true) {
      const selectedProjectKeys = this.teams.find(t => t.key == teamKey)?.projectKeys || []
      postQuery = query(postQuery, where("projectKey", "in", selectedProjectKeys))
      documentQuery = query(documentQuery, where("projectKey", "in", selectedProjectKeys))
    }
    if (this.unsubscribePosts) {
      this.unsubscribePosts()
    }
    let u = onSnapshot(postQuery, (snapshot) => { // this is used to get posts from firestore
      if (this.isListening == true) {
        const scrollPosition = this.scrollPosition
        this.posts = this.posts.filter(post => post.templateKey.toLowerCase() == "document")
        this.channelKey = projectKey
        snapshot.forEach((child) => {
          let post = this.preparePost(child, projectName, "post")

          if (post) {
            if (this.selectedContentKeys.includes(post.key)) {
              post.isSelected = true
            }
            if (post.projectKey != undefined && post.projectKey != "" ) {
              post.projectName = this.getProjectName(post.projectKey)
            }
            this.posts.push(post)
          }
        });
        this.filterSkippedContentTypes()
        this.tags.sort((a, b) => a.tag.localeCompare(b.tag))
        this.countPostsByTemplate()
        this.scrollToPosition(scrollPosition)
     //   setTimeout(() => { // for wroolo display only content from current project
          this.countPostsByProject()
       //   if (this.site == "wroolo") {
      //      this.filterByTemplate(projectKey)
      //    }
     //   }, 1000)
        pLoaded = true
        if (pLoaded == true && dLoaded == true) {
          this.getReadToggles().then(() => {
          if (this.filter != undefined && this.filter != "") {
            this.searchQuery = this.filter
            this.filterPosts()
          }
          this.getSelectedContentKeys().then(() => {
            if (this.donotShow == true) {
              let ps = this.posts.filter(post => post.isSelected == true)
              this.closeContentList.emit(ps)
            }
            for (let i = 0; i < this.posts.length; i++) {
              if (this.posts[i].isSelected == true) {
                this.service.responseSourceDocuments.push({"key": this.posts[i].key, "name": this.posts[i].name, "url": this.posts[i].coverImageURL, "ners": [], "coverImageURL": this.posts[i].coverImageURL, "contentKey": this.posts[i].key, "contentType": "post", "type": "post", "projectKey": this.posts[i].projectKey, "projectName": this.posts[i].projectName, "score": 1})
              }
            }
          })
        })

        }
        this.hideLoader()
      }
    }, error => {
      console.error(error)
      this.hideLoader()
    })

    let d = onSnapshot(documentQuery, (snapshot) => { // this is used to get documents from firestore
      if (this.isListening == true) {
        const scrollPosition = this.scrollPosition
        this.posts = this.posts.filter(post => post.templateKey.toLowerCase() != "document")
        snapshot.forEach((child) => {
          let document = this.preparePost(child, projectName, "document")
          if (document) {
            if (this.selectedContentKeys.includes(document.key)) {
              document.isSelected = true
            }
            if (document.projectKey != undefined && document.projectKey != "" ) {
              document.projectName = this.getProjectName(document.projectKey)
            }
            this.posts.push(document)
          }
        })
        this.filterSkippedContentTypes()
        this.tags.sort((a, b) => a.tag.localeCompare(b.tag))
        this.countPostsByTemplate()
        this.scrollToPosition(scrollPosition)
    //    setTimeout(() => {
          this.countPostsByProject()
          if (this.site == "wroolo") {
     //       this.filterByTemplate(projectKey)
          }
    //    }, 1000)
        dLoaded = true
        if (pLoaded == true && dLoaded == true) {
          this.getReadToggles().then(() => {
          if (this.filter != undefined && this.filter != "") {
            this.searchQuery = this.filter
            this.filterPosts()
          }
          this.getSelectedContentKeys().then(() => {
            if (this.donotShow == true) {
              let ps = this.posts.filter(post => post.isSelected == true)
              this.closeContentList.emit(ps)
            }
            for (let i = 0; i < this.posts.length; i++) {
              if (this.posts[i].isSelected == true && this.service.responseSourceDocuments.find(item => item.key == this.posts[i].key) == undefined) {
                this.service.responseSourceDocuments.push({"key": this.posts[i].key, "name": this.posts[i].name, "url": this.posts[i].coverImageURL, "ners": [], "coverImageURL": this.posts[i].coverImageURL, "contentKey": this.posts[i].key, "contentType": "post", "type": "post", "projectKey": this.projectKey, "projectName": this.projectName, "score": 1})
              }
            }
          })
        })
        }
      }
    })

    this.unsubscribePosts = u
    this.unsubscribeDocuments = d
  }

  closeWindow() {
    this.closeContentList.emit([])
  }

  filterSkippedContentTypes() {
    this.posts = this.posts.filter(post => !this.skippedContentKeys.includes(post.key))
    this.skippedContentTypes.forEach(type => {
      this.posts = this.posts.filter(post => post.templateKey.toLowerCase() != type.toLowerCase())
    })  
  }

  setNewPostValues() {
    this.newPost.projectKey = this.projectKey
    this.newPost.authorKey = this.userId
    this.newPost.projectName = this.projectName
    this.newPost.authorName = this.userDisplayName
    this.newPost.commentCount = 0
    this.newPost.organizationKey = this.organizationKey
    this.newPost.viewCount = 0
  }

  getProjectName(projectKey: string) {
    for (let i = 0; i < this.projects.length; i++) {
      if (this.projects[i].key == projectKey) {
        this.service.projectName = this.projects[i].name
        return this.projects[i].name
      }
    }
    return ""
  }



showFilterPopup() {
  this.isFilterPopupVisible = !this.isFilterPopupVisible
}

filterByTag(tag: string, index: number) {
  this.tags[index].isSelected = !this.tags[index].isSelected
  this.filterPosts()
}

clearTags() {
  this.tags.forEach(tag => tag.isSelected = false)
  this.filterPosts()
  this.showTagsPopup = false
}

filterByProject(projectKey: string = "") {
  if (projectKey == "") {
    this.showOneProjectOnly = false
  } else {
    this.showOneProjectOnly = true
  }
  this.startListening(this.projectKey, this.projectName, this.teamKey, this.filterByTeam, this.showOneProjectOnly) // projects are filtered differently, you need to relounch wjole query
}

showPostContextMenu(event: MouseEvent, postIndex: number) {
  event.stopPropagation()
  setTimeout(() => { // this is needed to avoid the issue that context menu is not shown when clicking on the post. there is a collision with the clickOutside function
  if (this.itemIndexContextMenu == postIndex) {
    this.itemIndexContextMenu = -1
  } else {
   // const rect = (event.target as HTMLElement).getBoundingClientRect();
    this.menuX = event.x-200; // or rect.left, as needed
    this.menuY = event.y; // or rect.top, as needed
    this.itemIndexContextMenu = postIndex
    this.selectedPostKey = this.posts[postIndex].key
    this.onSelectedPostKey.emit(this.selectedPostKey)
    this.selectedTemplateKey = this.posts[postIndex].templateKey
    this.selectedPost = this.posts[postIndex]
    this.selectedPostTemplateKey = this.selectedPost.templateKey || ""
  }
  }, 100)
}

clickOutside() {
  this.itemIndexContextMenu = -1
  this.selectedPostKey = ""
  this.closePostPanel()
  this.onSelectedPostKey.emit(this.selectedPostKey)
  this.selectedPostTemplateKey = ""
  this.isAddPostMenuVisible = false
}

hidePostContextMenu() {
  setTimeout(() => {
  this.itemIndexContextMenu = -1
//  this.selectedPostKey = ""
 // this.onSelectedPostKey.emit(this.selectedPostKey)
 // this.selectedPostTemplateKey = ""
  this.isAddPostMenuVisible = false
  }, 100)
  this.isContentListVisible = true
}

async toggleFavorite(postKey: string) {
  const postIndex = this.getPostByKey(postKey)
  this.posts[postIndex].isFavourite = !this.posts[postIndex].isFavourite
  this.postsBeforeFiltering[postIndex].isFavourite = !this.postsBeforeFiltering[postIndex].isFavourite
  await this.firestore.setContentReadToggles(this.organizationKey, this.userId, [{"contentKey": postKey, "isRead": this.posts[postIndex].isRead, "isTop": this.posts[postIndex].isTop, "isFavourite": this.posts[postIndex].isFavourite}]).then(() => {
    this.sortPosts(this.postsSortedBy)
    this.hidePostContextMenu()
  })
}

async togglePin(postKey: string) {
  const postIndex = this.getPostByKey(postKey)
  this.posts[postIndex].isTop = !this.posts[postIndex].isTop
  await this.firestore.setContentReadToggles(this.organizationKey, this.userId, [{"contentKey": postKey, "isRead": this.posts[postIndex].isRead, "isTop": this.posts[postIndex].isTop, "isFavourite": this.posts[postIndex].isFavourite}]).then(() => {
    this.sortPosts(this.postsSortedBy)
    this.hidePostContextMenu()
  })
}

async toggleRead(postKey: string) {
  const postIndex = this.getPostByKey(postKey)
  this.posts[postIndex].isRead = !this.posts[postIndex].isRead
  await this.firestore.setContentReadToggles(this.organizationKey, this.userId, [{"contentKey": postKey, "isRead": this.posts[postIndex].isRead, "isTop": this.posts[postIndex].isTop, "isFavourite": this.posts[postIndex].isFavourite}]).then(() => {
    this.sortPosts(this.postsSortedBy)
    this.hidePostContextMenu()
  })
}


showAddPostMenu() {
  setTimeout(() => {
    this.isAddPostMenuVisible = !this.isAddPostMenuVisible
  }, 100)
}


async deleteDocument(postKey: string) {
  this.hidePostContextMenu()
  const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
    data: {"content": "Do you want to delete this document?", "onlyCloseButton": false, "title": "Delete document"}
  });
  dialogConfirmingRef.afterClosed().subscribe((r) => { 
    if (r == true) {
      const url = this.posts.find(post => post.key == postKey)?.imageURLs[0].url
      if (url != undefined ) {
        this.firestore.removeImage(this.organizationKey, "", postKey, url)
        this.posts = this.posts.filter(post => post.key != postKey)
      }
    }
  })

}

  scrollToPosition(scrollPosition: number) {
    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth',
    });
  }

showFavourite(showOnly: boolean) {
  this.showFavouriteOnly = showOnly
  this.filterPosts()
}

searchByFilter() {
  this.filterPosts()
  this.searchQuery = ""
  this.isFilterPopupVisible = false
}

clearSearch() {
  this.searchQuery = ""
  this.activeFilters.length = 0
  this.filterPosts()
}

removeFilter(filter: string) {
  this.activeFilters = this.activeFilters.filter(item => item.content !== filter)
  this.searchQuery = ""
  this.filterPosts()
}

filterOnInputChange(value: string) { // detect that user cleared filtering input field
  if (value.trim() === '') {
    this.filterPosts()
  }
}

filterByTemplate(templateKey: string) { // filters posts by template and project
  if (this.shownTemplates.includes(templateKey)) {
    this.shownTemplates = this.shownTemplates.filter(item => item !== templateKey)
  } else {
    this.shownTemplates.push(templateKey)
  }
  this.filterPosts()
}

showAllTemplates() {
  this.shownTemplates = []
  this.filterPosts()
}

filterByPersona(personaKey: string) {
  if (this.shownPersonas.includes(personaKey)) {
    this.shownPersonas = this.shownPersonas.filter(item => item !== personaKey)
  } else {
    this.shownPersonas.push(personaKey)
  }
  this.filterPosts()
}

showAllPersonas() {
  this.shownPersonas = []
  this.filterPosts()
}

preparePost(child: any, projectName: string, type: string) {
  let title: any = child.data()["title"] || ""
  let dateOfCreation: any = child.data()["dateOfCreation"] || ""
  let authorKey: any = child.data()["authorKey"] || ""
  let authorName: any = child.data()["authorName"] || ""
  let dateOfUpdate: any = child.data()["dateOfUpdate"] || ""
  let nameHTML: any = child.data()["nameHTML"] || "" // TO TRZEBA BRAC Z CONTENTU
  let projectKey: any = child.data()["projectKey"] || ""
  let postKey: any = child.id;
  let date = new Date(dateOfCreation)
 // let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  let formattedDate = date.toLocaleDateString("pl-PL");
  let lastCommentDate = new Date(child.data()["lastCommentDate"])
  let commentCount: number = child.data()["commentCount"] || 0
  let categoryKey: any = child.data()["categoryKey"] || ""
  let viewCount: any = child.data()["viewCount"] || 0
  let contentRowsCount: any = child.data()["rowsCount"] || 0
  let name: any = child.data()["name"] || ""
  let isDeleted: any = child.data()["isDeleted"] || false
  let coverImageURL: any = child.data()["coverImageURL"] || ""
  let isDownloadAvailable: any = child.data()["isDownloadAvailable"] || false
  let templateKey: any = child.data()["templateKey"] || ""
  let contentType: any = child.data()["type"] || ""
  const fileType: any = child.data()["type"] || ""
  const url = child.data()["url"] || ""
  const urlType = child.data()["urlType"] || ""
  const tags: string[] = child.get("tags") || []
  const progressPercent: any = child.data()["progressPercent"] || 0
  const startDate = child.data()["startDate"] || ""
  const endDate = child.data()["endDate"] || ""
  const manHours = child.data()["manHours"] || 0
  const imageName = child.data()["imageName"] || ""

  const tagsSet = new Set(this.tags.map(tag => tag.tag))
  this.tags = Array.from(new Set([...tagsSet, ...tags])).map(t => ({ tag: t as string, isSelected: false })) // add to global tags array and remove duplicates
  const color = child.get("color") || "#ffffff"
  //const embedding: number[] = child.get("embedding") // I resigned from getting embedding vector for each posts for it is too big. Instead I will reloaded when searching for similar posts
  let fields: PostField[] = []
  let snapshotFields = child.get("fields")
  if (snapshotFields) {
    snapshotFields.forEach((childField: PostField) => {
      fields.push(childField)
   })
  }

  if (templateKey == undefined) {
    templateKey = "note"
  }
  if (isDownloadAvailable == undefined) {
    isDownloadAvailable = false
  }
  if (isDeleted != "true") {
    let templateName = this.templates.find(t => t.key == templateKey)?.name || templateKey
    templateName = this.capitalizeFirstLetter(templateName)
    let imageURLs: {url: string, type: string}[] = []
    if (type == "document") {
      contentType = "Document"
      templateName = "Document"
      imageURLs.push({"url": url, "type": urlType})
      name = imageName
      templateKey = "document"
    }

    let post: Post = {"title": title, "key": postKey, "dateOfCreation": date, "dateOfUpdate": new Date(dateOfUpdate), "formattedDate": formattedDate, "authorKey": authorKey, "authorName": authorName, "nameHTML": nameHTML, "imageURLs": imageURLs, "coverImageURL": coverImageURL, "commentCount": commentCount, "viewCount": viewCount, "lastCommentDate": lastCommentDate, "categoryKey": categoryKey, "name": name, "contentRowsCount": contentRowsCount, "organizationKey": this.organizationKey, "projectKey": projectKey, "isNewPost": false, "isDeleted": false, "loggedUserDisplayName": "", "loggedUserKey": "", "isDownloadAvailable": isDownloadAvailable, "projectName": projectName, "templateKey": templateKey, "color": color, "fields": fields, "tags": tags, "contentType": contentType, "embedding": [], "isRead": false, "isTop": false, "isFavourite": false, "progressPercent": progressPercent, "startDate": startDate, "endDate": endDate, "manHours": manHours, "isSelected": false, "templateName": templateName, "areKidsColored": false, "areKidsTagged": false, "isCompleted": false, "parentName": "", "isParent": false, "assignedUsers": [], "status": "", "sequence": 0, "parentKey": "", "isExpanded": false, "milestoneKey": "", "isChecked": false, "description": "", "fileType": fileType}
      return post

  } else {
    return null
  }
}

capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

async addPost(templateKey: string, showDialog: boolean, initialContent: string = "", automaticAnalysis: boolean = false, contentKey: string = "") { // adds new post
  let key = ""
  if (templateKey == "canvas") {
   this.router.navigate(["/canvaslist", this.organizationKey, this.projectKey])
  } else  if (templateKey == "document") { // if document is added, show add document popup
    this.showDropFilesPopup()
  } else { // adding post with template
    if (contentKey == "") {
      key = await this.firestore.addWorkpackage(this.organizationKey, this.projectKey, this.userId, false, -1, "", "", templateKey, true, "post", "", "tap to edit this piece of knowledge").then(key => {
        return key
      })
    } else {
      key = contentKey
      await this.firestore.addWorkpackageWithKey(this.organizationKey, this.projectKey, contentKey, this.userId, "post with attached files", false, -1, "", "", false, templateKey, "post", "")
    }
    let templateIndex = this.firestore.getTemplateIndex(templateKey, this.templates)
    let fields: PostField[] = []
    if (templateIndex > -1 || templateKey == 'diary' || templateKey == 'link' || templateKey == 'image') {
      if (automaticAnalysis == true) {
        //NARAZIE WYŁACZAM GENEROWANIE TAGOW BO NIE MA CZASU NA TO
        //this.search.generateTags(this.organizationKey, key, this.tags.map(tag => tag.tag.toLowerCase()), fields, this.newPost.tags, initialContent, -1, true)
      }
      if (templateKey == 'diary') {
        fields = this.firestore.addDiaryFields(fields)
      } else if (templateKey == 'link') {
        fields = this.firestore.addLinkFields(fields)
      } else if (templateKey == 'image') {
        fields = this.firestore.addImageFields(fields, initialContent)
      } else {
        fields = this.firestore.generateFields(this.templates[templateIndex].fields)
      }
      if (initialContent != "") {
        let isAdded = false
        for (let i = 0; i < fields.length; i++) {
          if (fields[i].type == "html") {
            fields[i].content = initialContent
            isAdded = true
          }
          break;
        }
        if (isAdded == false) {
          const uid = this.firestore.generateUID()
          fields.unshift({"key": "htmlContent"+uid, "content": initialContent, "placeholder": "type description", "type": "html", "noteType": "html", "sequence": 1, "links": [], "uid": uid, "date": "", "isExpanded": true, "label": ""})
          fields.unshift({"key": "htmlContentlabel"+uid, "content": "Description", "placeholder": "type description", "type": "label", "noteType": "label", "sequence": 1, "links": [], "uid": uid, "date": "", "isExpanded": true, "label": "Description"})
        }
      }
    }
    let i = this.getPostByKey(key)
    await this.firestore.updateWorkpackageFields(this.organizationKey, key, fields).then(() => {
      if (i == -1) {
        const templateName = this.templates.find(t => t.key == templateKey)?.name || ""
        const post: Post = {"authorKey": this.userId, "authorName": this.userDisplayName, "categoryKey": "", "commentCount": 0, "nameHTML": "", "contentRowsCount": 0, "dateOfCreation": new Date(), "dateOfUpdate": new Date(), "formattedDate": "", "imageURLs": [], "coverImageURL": "", "key": key, "lastCommentDate": new Date(), "organizationKey": "", "name": "", "projectKey": this.projectKey, "title": "", "viewCount": 0, "isNewPost": true, "isDeleted": false, "loggedUserDisplayName": this.userDisplayName, "loggedUserKey": this.userId, "isDownloadAvailable": false, "projectName": this.projectName, "templateKey": templateKey, "color": "#ffffff", "fields": [], "tags": [], "contentType": "", "embedding": [], "isRead": false, "isTop": false, "isFavourite": false, "progressPercent": 0, "startDate": new Date(), "endDate": new Date(), "manHours": 0, "isSelected": false, "templateName": templateName, "areKidsColored": false, "areKidsTagged": false, "isCompleted": false, "parentName": "", "isParent": false, "assignedUsers": [], "status": "", "sequence": 0, "parentKey": "", "isExpanded": false, "milestoneKey": "", "isChecked": false, "description": "", "fileType": ""}
        this.posts.push(post)
        i = this.posts.length-1

      }
      if (i > -1) {
        let post = this.posts[i]
        let captureImage = false
        if (templateKey == 'image') {
          captureImage = true
        }
        if (showDialog == true) {
          this.openPostPanel(key, true, templateKey, post, captureImage)
       //   this.launchPostDialog(key, "", "", true, templateKey, post, captureImage)
        }
      } else {
        console.error("Didn't find the post. Something went wrong.")
      }
      return
    })
    if (initialContent != "") {
      let coverContent = ""
      for (let j = 0; j < fields.length; j++) {
          coverContent += "<p>" + fields[j].content + "</p>"
      }
      this.posts[i].nameHTML = coverContent
      this.posts[i].name = this.stripTags(coverContent)
      await this.firestore.updateWorkpackageName(this.organizationKey, this.projectKey, this.projectName, this.posts[i].key, this.userId, this.userDisplayName, this.posts[i].name, "", this.posts[i].contentType, this.embeddingModel, this.posts[i].nameHTML, fields).then(() => {
        this.hideLoader()
      }).catch((error: any) => {
        console.error("error", error)
        this.hideLoader()
      })
    }
  }
  return key
}

stripTags(htmlString: string) {
  var div = document.createElement("div");
  div.innerHTML = htmlString;
  return div.innerText;
}

filterPosts() { // filters posts by keywords
  const q = this.searchQuery.trim().toLowerCase()
  if (!this.activeFilters.some(item => item.content === q) && q.length > 0) {
    this.activeFilters.push({content: q, displayName: q.slice(0, 10)})
  }

  if (this.activeFilters.length > 0) { // Parse active filters into arrays of words per filter
    const filtersWords: string[][] = this.activeFilters.map(item =>
      item.content.split(/[,\s.:-;\n]+/).filter(Boolean) // removes empty strings
    );

    this.posts = this.postsBeforeFiltering.filter((obj: Post) => {
      // Get the name or nameHTML in lowercase for search
      let name = (obj.name || obj.nameHTML || "").toLowerCase();

      // Check if post satisfies ANY row: i.e. that the post contains ALL words in that row
      return filtersWords.some(words => 
        words.every(word => name.includes(word))
      );
    }).map(obj => ({ ...obj }));
  } else {
    this.posts = this.postsBeforeFiltering.map(obj => ({ ...obj }));
  }

  if (this.showFavouriteOnly === true) { // filters posts by favourite
    this.posts = this.posts.filter(obj => obj.isFavourite === true).map(obj => ({ ...obj }));
  }

  if (this.shownTemplates.length > 0) {
    this.posts = this.posts.filter(obj =>
      this.shownTemplates.includes(obj.templateKey) || this.shownTemplates.includes(obj.projectKey)
    ).map(obj => ({ ...obj }));
  }

  let selectedTags = this.tags.filter(tag => tag.isSelected === true);
  if (this.shownPersonas.length > 0) {
    this.shownPersonas.forEach(persona => {
      selectedTags.push({"tag": persona, "isSelected": true})
    })
  } 
  if (selectedTags.length > 0) {
    this.posts = this.posts.filter(obj =>
      selectedTags.some(tag => obj.tags.includes(tag.tag))
    );
  }
}

sortPosts(criteria: string, isAscending: boolean = true) {
  this.postsSortedByAscending = isAscending
  this.postsSortedBy = criteria
  if (criteria != 'alphabet' && criteria != 'date' && criteria != 'project' && criteria != 'template') {
    this.postsSortedBy = 'alphabet'
  }

  if (this.postsSortedBy == 'alphabet') {
    if (isAscending == true) {
      this.posts.sort(function (a, b) {
        const nameA = (a.name || '').toLowerCase();
        const nameB = (b.name || '').toLowerCase();
        if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    })
  } else {
    this.posts.sort(function (a, b) {
      const nameA = (a.name || '').toLowerCase();
      const nameB = (b.name || '').toLowerCase();
      if (nameA > nameB) {
      return -1;
    }
    if (nameA < nameB) {
      return 1;
    }
    return 0;
  })
  }
  } else if (this.postsSortedBy == 'date') {
    if (isAscending == true) {
      this.posts.sort(function (a, b) {
        return b.dateOfUpdate.getTime() - a.dateOfUpdate.getTime();
      })
    } else {
      this.posts.sort(function (a, b) {
        return a.dateOfUpdate.getTime() - b.dateOfUpdate.getTime();
      })
    }
  } else if (this.postsSortedBy == 'project') {
    if (isAscending == true) {
      this.posts.sort(function (a, b) {
        return a.projectName.localeCompare(b.projectName);
      })
    } else {
      this.posts.sort(function (a, b) {
        return b.projectName.localeCompare(a.projectName);
      })
    }
  } else if (this.postsSortedBy == 'template') {
    if (isAscending == true) {
      this.posts.sort(function (a, b) {
        return a.templateName.localeCompare(b.templateName);
      })
    } else {
      this.posts.sort(function (a, b) {
        return b.templateName.localeCompare(a.templateName);
      })
    }
  }
  this.posts.sort(function (a, b) { // sort not read posts higher
    if (a.isTop == true && b.isTop == false) {
      return -2
    } else if (a.isRead === false && b.isRead === true) {
      return -1; // a should come before b
    } else if (a.isRead === true && b.isRead === false) {
      return 1; // a should come after b
    } else {
      return 0; // no change in order
    }
  })
  this.hideLoader()
  this.initiateScrollDetection()
}

async getReadToggles() { // retrieves statuses of user read posts
  this.showLoader("Retrieving read statuses of posts...")
  await this.firestore.getContentReadToggles(this.organizationKey, this.userId).then(result => {
    result.personalReadToggles.forEach(toggle => {
      const contentKey = toggle.contentKey
      const ind = this.getPostByKey(contentKey)
      if (ind > -1) {
        this.posts[ind].isRead = toggle.isRead
        this.posts[ind].isTop = toggle.isTop
        this.posts[ind].isFavourite = toggle.isFavourite
      }
    })
    this.postsLoaded = true
    this.sortPosts(this.postsSortedBy)
    this.postsBeforeFiltering = this.posts.map(obj => ({...obj}));
    this.hideLoader()
  })
}

initiateScrollDetection() { 
  setTimeout(() => {
    const targetElement = document.getElementById("showmoreposts") as HTMLElement;
    if (!targetElement) {
      return;
    }
    // Define the scrollListener
    this.scrollListener = () => {
      const windowHeight = window.innerHeight;
      const scrollPosition = (window.scrollY || window.pageYOffset) + windowHeight;
      const targetPosition = targetElement.offsetTop;
      
      // Check if the scroll position is beyond the target position
      if (scrollPosition >= targetPosition) {
        this.removeScrollListener(); // Remove listener to prevent multiple triggers
        setTimeout(() => {
          this.incrementVisible();
          this.initiateScrollDetection(); // Re-initiate detection for further scrolls
        }, 200);
      }
    };
    window.addEventListener('scroll', this.scrollListener);     // Attach the scroll listener
  }, 2000);
}

countPostsByTemplate() {
  for (let i = 0; i < this.menuItems.length; i++) {
    this.menuItems[i].count = this.posts.filter(post => post.templateKey == this.menuItems[i].key).length
  }
}

private removeScrollListener() {
  if (this.scrollListener) {
    window.removeEventListener('scroll', this.scrollListener);
    this.scrollListener = null;
  }
}

async updateProject(projectKey: string) {
  this.hidePostContextMenu()
  this.closePostPanel()
  if ((this.projectKey != undefined && projectKey != undefined && projectKey != "")) {
    this.projectKey = projectKey
    this.shownTemplates.length = 0
    this.service.changeProject(this.projectKey)
    await this.startListening(this.projectKey, this.projectName, this.selectedTeamKey, this.filterByTeam, true)
    this.filterPosts()
  } else {
    await this.startListening(this.projectKey, this.projectName, this.selectedTeamKey, this.filterByTeam, false)
  }
}

async openPostPanel(postKey: string, isNewPost: boolean, templateKey: string, post: Post = this.newPost, captureImage: boolean = false) {
  this.isListening = false
  if (postKey != undefined && templateKey != undefined && templateKey != "canvas") {

    if (post.key != undefined && post.key != '') {
      let fields = await this.firestore.getWorkpackageFields(this.organizationKey, post.key)

        if (fields == undefined && post.contentType != "canvas") { // in case of canvas in knowledge base do not generate template fields
          let templateIndex = this.firestore.getTemplateIndex(templateKey, this.templates)
          if (templateIndex > -1) {
            fields = this.firestore.generateFields(this.templates[templateIndex].fields)
          }
        }
        if (post.contentType != "canvas" && fields != undefined) { // for posts open popup
          if (templateKey == 'diary' && this.isReadOnly == false) { // every time diary post is opened, add new diary fields
            fields = this.firestore.addDiaryFields(fields)
          }
        }
    this.selectedPostKey = postKey
    this.onSelectedPostKey.emit(this.selectedPostKey)
    this.isPostPanelOpen = true
    this.post = post
    this.post.fields = fields
    this.templateKey = templateKey
    this.type = this.post.contentType
    this.manHours = this.post.manHours
    this.progressPercent = this.post.progressPercent || 0
    this.isNewPost = isNewPost
    this.captureImage = captureImage
        


    }

  } else if (postKey != undefined && templateKey == "canvas") {
    this.router.navigate(["storymap/"+this.organizationKey+"/"+this.projectKey+"/"+postKey])
    this.hidePostContextMenu()
  }
  this.isListening = true
}

closePostPanel() {
  this.isPostPanelOpen = false
  this.selectedPostKey = ""
  this.onSelectedPostKey.emit(this.selectedPostKey)
}

updateStatus(event: any) {

}

updateColor(event: any) {

}

updateName(event: any) {

}

updateCoverImage(event: any) {

}

updateComplete(event: any) {

}

updateDelete(event: any) {

}

onListenContent(listen: any) {
  this.isListening = listen as boolean
}

close(event: any) {
  this.closePostPanel()
}

  loadDocument(urlLink: string) {
    this.getURL(urlLink).then(url => {
      window.open(url, "_blank")
    })
  }

   async getURL(urlLink: string) {
    const storage = getStorage();
    const imageRef = ref(storage, urlLink);
    return await getDownloadURL(imageRef)
        .then((url) => {
          return url
    });
  }

  setColorClicked() {
    this.isColorPalleteVisible = !this.isColorPalleteVisible
  }

   changeColorComplete(event: any, postKey: string) {
    this.itemIndexContextMenu = -1
    this.color = event.color.hex
    this.isColorPalleteVisible = false
    this.isListening = false
     this.firestore.updateWorkpackageColor(this.organizationKey, postKey, this.color, false).then(() => {
      this.isListening = true
      const n = this.getPostByKey(postKey)
      this.posts[n].color = this.color
    })
  }

  async addNewPost(templateKey: string = "diary", initialContent: string = "") { // adds new post with automatic analysis straight from window on feed
    const templateIndex = this.firestore.getTemplateIndex(templateKey, this.templates)
    if (templateIndex == -1) {
      templateKey = this.templates[0].key
    }
    let contentKey = ""
    if (initialContent != "") {
      this.newPostName = initialContent
    }
    if (this.newPostName.length > 0) {
      this.isListening = false
      const name = this.newPostName
      this.newPostName = ""
      this.firestore.showSnackBar("New post is being added. Please wait...")
      contentKey = await this.addPost(templateKey, false, name, true).then((result) => {
        this.sortPosts(this.postsSortedBy)
        this.firestore.showSnackBar("New post added.")
        this.isListening = true
        this.hideLoader()
        return result
      })
    } else {
      this.firestore.showSnackBar("You need to enter some content.")
      contentKey = ""
    }
    return contentKey
  }

  onFileUploaded(event: any) {
    this.addPost("document", false, this.newPostName, false, this.newPostKey).then(() => {
      this.sortPosts(this.postsSortedBy)
      this.firestore.showSnackBar("New post added.")
      this.isListening = true
      this.hideLoader()
      this.newPostKey = this.firestore.generateUID("content-")
      this.newPostName = ""
    }).catch((error: any) => {
      console.error("error", error)
      this.hideLoader()
    })
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
      this.addNewPost()
    }
    if (event.key === 'Escape') {
      this.hidePostContextMenu()
      this.closePostPanel()
      this.selectedContentKeys = []
      this.onSelectedContent.emit([])
      this.service.responseSourceDocuments = []
      this.service.changeSelectedContentKeys([])
      this.service.currentSelectedContentKeys = []
      this.service.selecteDocumentContent = ""
    }
  }

  hideLoader() {
    this.isLoadingLabelVisible = false
    this.isLoadingLabelVisibleEmitter.emit(false)
    this.loaderMessageEmitter.emit("")
    this.loaderMessage = ""
  }

  showLoader(message: string) {
    this.isLoadingLabelVisible = true
    this.isLoadingLabelVisibleEmitter.emit(true)
    this.loaderMessageEmitter.emit(message)
    this.loaderMessage = message
  }

  async launchPostDialog(postKey: string, postName: string, postHTMLName: string, isNewPost: boolean, templateKey: string, post: Post = this.newPost, captureImage: boolean = false) {
    if (post.key != undefined && post.key != '') {
      this.firestore.getWorkpackageFields(this.organizationKey, post.key).then(f => {
        let fields = f
        if (fields == undefined && post.contentType != "canvas") { // in case of canvas in knowledge base do not generate template fields
          let templateIndex = this.firestore.getTemplateIndex(templateKey, this.templates)
          if (templateIndex > -1) {
            fields = this.firestore.generateFields(this.templates[templateIndex].fields)
          }
        }
        if (post.contentType != "canvas" && fields != undefined) { // for posts open popup
        //  if (templateKey != 'image') { // if image is added, listen for changes cause image description is conducted on server side in the background and post list must be reloaded once it is done
        //    this.isListening = false
        //  }
          if (templateKey == 'diary' && this.isReadOnly == false) { // every time diary post is opened, add new diary fields
            fields = this.firestore.addDiaryFields(fields)
          }
          const dialogRef = this.dialog.open(AddworkpackagedialogComponent, {
            disableClose: true,
            panelClass: "dialog-container",
            height: 'calc(100vh - 30px)',
            width: 'calc(100vw - 10px)',
            maxWidth: '100vw',
            maxHeight: '100vh', 
            data: {
              post: post,
              menuItems: this.menuItems,
              key: post.key,
              name: postName,
              HTMLname: postHTMLName,
              isNewPost: isNewPost,
              organizationKey: this.organizationKey,
              projectKey: post.projectKey,
              projectName: this.projectName,
              color: post.color,
              content: post.nameHTML,
              title: post.title,
              viewCount: post.viewCount,
              userId: this.userId,
              userDisplayName: this.userDisplayName,
              loggedUserKey: this.userId,
              templateKey: templateKey,
              fields: fields,
              templates: this.templates,
              fieldKeyWithLinks: this.fieldKeyWithLinks,
              channelKey: post.key,
              tags: post.tags,
              coverImageURL: post.coverImageURL,
              contentType: post.contentType,
              type: "post",
              isRead: post.isRead,
              isTop: post.isTop,
              isFavourite: post.isFavourite,
              isReadOnly: this.isReadOnly,
              postEmbedding: post.embedding,
              embeddingModel: this.embeddingModel,
              captureImage: captureImage,
              globalTags: this.tags.map(tag => tag.tag.toLowerCase()),
              startDate: post.startDate,
              endDate: post.endDate,
              manHours: post.manHours,
              progressPercent: post.progressPercent,
              selectedTeamKey: this.selectedTeamKey
            }, 
          });
  
          const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
            if (size.matches) { // https://blog.andrewwebster.dev/2018/05/angular-material-full-size-dialog-on.html
              dialogRef.updateSize('100%', '100%');
        } else {
          dialogRef.updateSize('98vw', 'calc(100vh - 30px)');
          }
      });
          dialogRef.afterClosed().subscribe((result: any) => { // when post or task dialog is closed, store data in the database
            if (result == undefined) {
              this.isListening = false
            } else {
              this.isListening = result.isListening || false
            }
            this.scrollPosition = window.scrollY
            smallDialogSubscription.unsubscribe();
            if ((result != undefined)&&(result != "")) {
              if (result.isDownloadAvailable == undefined) {
                result.isDownloadAvailable = false
              }
             //let color = result.color
              //let areKidsColored = result.areKidsColored
              
              let name = result.name
              let nameHTML = result.htmlName || name
              const n = this.getPostByKey(postKey)
              if (result.isDeleted == true) {
                this.posts.splice(n, 1)
              } else if (result.isPostUpdated == true) {
                this.posts[n].nameHTML = nameHTML
                this.posts[n].name = name
                this.posts[n].dateOfUpdate = new Date()
                this.sortPosts(this.postsSortedBy)
                  setTimeout(() => {
                    this.isListening = true
                  }, 6000)
              }
          }
          });
        } else if (post.contentType == 'canvas') { // for canvases just redirect to canvas
          let canvasKey = post.key
          this.router.navigate(["storymap/"+this.organizationKey+"/"+this.projectKey+"/"+canvasKey])
        } else if (fields == undefined) {
          this.firestore.showSnackBar("This content cannot be displayed.")
          if (this.isReadOnly == false) {
            const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
              //width: '400px',
              data: {"content": "This content seems to be broken. Do you want to delete it?", "onlyCloseButton": false, "title": "Delete content"}
            });
            dialogConfirmingRef.afterClosed().subscribe((r) => { 
              this.hideLoader()
              if (r == true) {
                this.firestore.showSnackBar("The task has been deleted.");
                this.firestore.removePost(post.key, this.organizationKey, this.projectKey)
                this.posts.splice(this.getPostByKey(post.key), 1)
              }
            })
          }
        }
      })
    }
  }

  getPostByKey(key: string) {
    for (let i = 0; i < this.posts.length; i++) {
      if (this.posts[i].key == key) {
        return i
      }
    }
    return -1
  }

  async getSelectedContentKeys() {
    this.selectedContentKeys = await this.firestore.getSelectedContentKeys(this.organizationKey, this.projectKey, this.userId)
    if (this.selectedContentKeys.length > 0) {
      this.service.currentSelectedContentKeys = this.selectedContentKeys
    }
    for (let i = 0; i < this.posts.length; i++) {
      if (this.selectedContentKeys.includes(this.posts[i].key)) {
        this.posts[i].isSelected = true
      } else {
        this.posts[i].isSelected = false
      }
    }
    this.onSelectedContent.emit(this.posts.filter(post => post.isSelected == true))
  }

  selectContent(contentKey: string) {
    this.hidePostContextMenu()
    this.selectedContentKeys.push(contentKey)
    const index = this.posts.findIndex(post => post.key == contentKey)
    this.posts[index].isSelected = true
    this.service.responseSourceDocuments.push({"key": contentKey, "name": this.posts[index].name, "url": this.posts[index].coverImageURL, "ners": [], "coverImageURL": this.posts[index].coverImageURL, "contentKey": contentKey, "contentType": "post", "type": "post", "projectKey": this.projectKey, "projectName": this.projectName, "score": 1})
    this.service.changeSelectedContentKeys(this.selectedContentKeys)
    this.addLinkedDocumentsToSelectedPosts(contentKey)
    const selectedPosts = this.posts.filter(post => post.isSelected == true)
    this.firestore.storeSelectedContentKeys(this.organizationKey, this.projectKey, this.userId, this.selectedContentKeys)
    this.onSelectedContent.emit(selectedPosts)
  }

  deselectContent(contentKey: string) {
    this.hidePostContextMenu()
    this.selectedContentKeys = this.selectedContentKeys.filter(key => key != contentKey)
    const index = this.posts.findIndex(post => post.key == contentKey)
    this.posts[index].isSelected = false
    this.service.responseSourceDocuments = this.service.responseSourceDocuments.filter(item => item.contentKey != contentKey)
    this.service.changeSelectedContentKeys(this.selectedContentKeys)
    const selectedPosts = this.posts.filter(post => post.isSelected == true)
    this.firestore.storeSelectedContentKeys(this.organizationKey, this.projectKey, this.userId, this.selectedContentKeys)
    this.onSelectedContent.emit(selectedPosts)
  }

  selectAllPosts() {
    this.hidePostContextMenu()
    this.areAllPostsSelected = true
    this.selectedContentKeys = this.posts.map(post => post.key)
    for (let i = 0; i < this.posts.length; i++) {
      this.posts[i].isSelected = true
      this.addLinkedDocumentsToSelectedPosts(this.posts[i].key)
      this.service.responseSourceDocuments.push({"key": this.posts[i].key, "name": this.posts[i].name, "url": this.posts[i].coverImageURL, "ners": [], "coverImageURL": this.posts[i].coverImageURL, "contentKey": this.posts[i].key, "contentType": "post", "type": "post", "projectKey": this.projectKey, "projectName": this.projectName, "score": 1})
    }
    this.service.changeSelectedContentKeys(this.selectedContentKeys)
    this.onSelectedContent.emit(this.posts)
  }

  deselectAllPosts() { 
    this.hidePostContextMenu()
    this.areAllPostsSelected = false
    this.selectedContentKeys = []
    for (let i = 0; i < this.posts.length; i++) {
      this.posts[i].isSelected = false
    }
    this.service.responseSourceDocuments.length = 0
    this.service.changeSelectedContentKeys(this.selectedContentKeys)
    this.onSelectedContent.emit([])
  }

  async deletePost(postKey: string) {
    this.hidePostContextMenu()
    const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
      data: {"content": "Do you want to delete it?", "onlyCloseButton": false, "title": "Delete content"}
    });
    dialogConfirmingRef.afterClosed().subscribe((r) => { 
      if (r == true) {
        this.isListening = false
        this.posts.splice(this.getPostByKey(postKey), 1)
        this.firestore.showSnackBar("Content has been deleted.");
        this.firestore.removePost(postKey, this.organizationKey, this.projectKey).then(() => {
          this.isListening = true
        })
      }
    })
  }

  async addFilesByDragging(files: FileList, attachToPost: boolean = true) {  // adding files by dragging and dropping
    if (files.length > 0 && attachToPost == true) {
      const key = await this.addPost("image", false, "Files uploaded from computer", false, "")
      const i = this.posts.length-1
      await this.addFilesToPost(key, files, i)
    } else if (files.length > 0 && attachToPost == false) {
      const maxFiles = 10
      if (files.length < maxFiles) {
        const filesArray = Array.from(files)
        this.processFilesSequentially(filesArray, 0);
      } else {
        this.firestore.showSnackBar("You can upload maximum 10 files at once.")
      }
    }
  }

  private processFilesSequentially(files: File[], index: number, isQuestionAboutAudioTranscription: boolean = false, doMakeAudioTranscription: boolean = false, removeAudioFileAfterTranscription: boolean = true): void { // processes files dragged one by one
    if (index >= files.length) {
      return; // Exit condition, all files processed
    }
    const file = files[index];
    const fileType = file.type

    let contentKey = "" // there is no content key for the document uploaded from computer, because document is not related to any post
    // Open dialog for the current file
    this.dialogRef = this.dialog.open(UploadpopupComponent, {
      panelClass: "dialog-container",
      data: {
        "userId": this.userId,
        "contentKey": contentKey,
        "file": file,
        "organizationKey": this.organizationKey,
        "projectKey": this.projectKey,
        "contentType": "document",
        "doAddCover": false,
        "objectType": "document",
        "projectName": this.projectName,
        "userImageUpload": false,
        "coverImageURL": "",
        "closeAfterImageCapture": false,
        "isQuestionAboutAudioTranscription": isQuestionAboutAudioTranscription,
        "doMakeAudioTranscription": doMakeAudioTranscription,
        "removeAudioFileAfterTranscription": removeAudioFileAfterTranscription
      }
    });
  
    this.dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result != false && result.documentKey != undefined) {
        const documentKey = result.documentKey;

        isQuestionAboutAudioTranscription = result.isQuestionAboutAudioTranscription
        doMakeAudioTranscription = result.doMakeAudioTranscription
        removeAudioFileAfterTranscription = result.removeAudioFileAfterTranscription
        const content = result.textContent

        if (content == undefined || content == "") {
          this.firestore.showSnackBar("Unable to read content of this file.")
          return
        }
        if ((fileType.startsWith("audio") || fileType.startsWith("video"))) {
          contentKey = await this.addNewPost("note", content)
          if (contentKey != "") {
            this.firestore.readContent(this.organizationKey, this.projectKey, contentKey, this.embeddingModel, "post")
          }
        }
        
        if (removeAudioFileAfterTranscription == true && (fileType.startsWith("audio") || fileType.startsWith("video"))) {
          this.deleteDocument(documentKey)
        } else {
          if (content != "") {  
            await this.firestore.updateDocumentTextContent(this.organizationKey, documentKey, content) // if content is extracted from office file, update document text content
          }
          this.search.readDocument(this.organizationKey, this.userId, this.projectKey, contentKey, documentKey, this.embeddingModel, result.fileType)
        }
      }
  
      // Once the dialog for the current file is closed, process the next file
      this.processFilesSequentially(files, index + 1, isQuestionAboutAudioTranscription, doMakeAudioTranscription, removeAudioFileAfterTranscription);
    });
  }

  async extractTextFromAudio(url: string, fileType: string) {
    this.hidePostContextMenu()
    this.showLoader("Extracting audio transcription...")
    const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
      //width: '400px',
      data: {"content": "If this file is large, extracting text may take up to 5 minutes. Don't close this page until the transcription is completed. Do you want to proceed?", "onlyCloseButton": false, "title": "It will take some time..."}
    });
    dialogConfirmingRef.afterClosed().subscribe(async (r) => { 
      this.hideLoader()
      if (r == true) {
        const path = await this.firestore.getDownloadURL(url)
        const content = await this.search.getGeminiAudioTranscription(path, fileType).then((result: any) => {
          this.firestore.showSnackBar("Audio transcription has been extracted.")
          this.hideLoader()
          return result
        }).catch((error: any) => {
          console.error("error", error)
          this.firestore.showSnackBar("Error during audio transcription extraction.")
          this.hideLoader()
          return ""
        }) 

        if (content != "") {
          const contentKey = await this.addNewPost("note", content)
          this.firestore.showSnackBar("New post with audio transcription has been created.")
          if (contentKey != "") {
            this.firestore.readContent(this.organizationKey, this.projectKey, contentKey, this.embeddingModel, "post")
          }
        }
      }
    })

  }

  async addFilesToPost(contentKey: string, files: FileList, postIndex: number) { // adds files to post, used when files are uploaded from computer by dragging and dropping
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      this.pdfSrc = URL.createObjectURL(file);
      const result = await this.firestore.uploadFile(file, contentKey, "", this.projectName, this.organizationKey, this.userId, contentKey, this.projectKey, "post", false, "", "content")
      this.pdfSrc = ""
      if (result != undefined && result != "" && typeof result === 'string') {
        this.posts[postIndex].isDownloadAvailable = true
        this.posts[postIndex].imageURLs.push({"url": result, "type": file.type})
      }
    }
  }

  showDropFilesPopup() {
    setTimeout(() => {
      this.showFileDropPopup = !this.showFileDropPopup
      this.showPDFPreview = !this.showPDFPreview
      if (this.showFileDropPopup == true) {
        this.hidePostContextMenu()
      }
      this.isContentListVisible = false
    }, 100)
  }

  async onFileDropped(event: FileList, attachToPost: boolean = true) {
    if (event.length > 0) {
      await this.addFilesByDragging(event, attachToPost)
    }
    this.showFileDropPopup = false
    setTimeout(() => {
      this.showPDFPreview = false
    }, 5000)
    this.isContentListVisible = true
  }

  async afterLoadComplete(pdfData: any) { // launched when pdf loading completed
    let textContent = ""
    this.loaderMessage = "File has been uploaded, extracting its content..."
    await this.firestore.getPDFText(pdfData).then((pages: any)=> {
        textContent = ""
        pages.forEach((page: any) => {
          page.forEach((txt: any) => {
            textContent += txt.str + " "
          })
        })
        if (textContent == "") {
          this.firestore.showSnackBar("Unable to read content of this file.")
        }
      })
    }


  addLinkedDocumentsToSelectedPosts(postKey: string) {
    this.firestore.getWorkpackageFiles(this.organizationKey, postKey).then((result: any) => {
      const snapshotFields = result
      let fields: PostField[] = []
      if (snapshotFields) {
        snapshotFields.forEach((childField: any) => {
          if (childField.type && !childField.type.startsWith("image")) { // only add files that are not images
            this.service.responseSourceDocuments.push({"key": childField.key, "name": childField.name, "url": childField.url, "ners": [], "coverImageURL": childField.coverImageURL, "contentKey": postKey, "contentType": "document", "type": "document", "projectKey": this.projectKey, "projectName": this.projectName, "score": 1})
          }
        })
      }
    })
}

incrementVisible() {
  this.visiblePosts += this.postVisibleIncrement
}

countPostsByProject() {
  for (let i = 0; i < this.projects.length; i++) {
    this.projects[i].count = this.posts.filter(post => post.projectKey == this.projects[i].key).length
  }
}

async getPersonas() {
  await this.firestore.getTags(this.organizationKey).then((result: any) => {
    let personas: {"name": string, "key": string, "description": string}[] = []
    result.docs.forEach((child: any) => {
      const teamKey = child.get("teamKey")
      if (teamKey == this.selectedTeamKey) {
        personas.push({"name": child.get("name"), "key": child.id, "description": child.get("description")})
      }
    })
    this.personas = personas
  })
}

async getSlackMessages() {
  const slackChannelKey = "C06H17CSNRL"
  const messages = await this.search.getSlackMessages(slackChannelKey)
  this.postToSlack("zintegrowanie z slackiem!", slackChannelKey)
}


async postToSlack(message: string, channel: string) {
  const result = await this.search.postToSlack(message, channel)
}






























projectNumber = ""
clientId = ".apps.googleusercontent.com" 
apiKey = ""
SCOPES = 'https://www.googleapis.com/auth/drive.readonly';
// --- State Variables ---
userAccessToken: string | null = null; // This is what you need!
isLoggedIn = false;
showPicker = false; 
googleApiReady = false;
private tokenClient: any;

// --- Authentication (Getting the Token) ---


async initGoogleAuthClient() {
  if (typeof google === 'undefined' || !google.accounts || !google.accounts.oauth2) {
    console.error('Google Identity Services not available. Ensure the script has loaded correctly.');
    return;
  }
  // This initializes the token client

   this.tokenClient = await google.accounts.oauth2.initTokenClient({
    client_id: this.clientId,
    scope: this.SCOPES,
    callback: (tokenResponse: any) => {
      // This callback is triggered when the user successfully signs in
      // and grants permission.
      if (tokenResponse && tokenResponse.access_token) {
        // Store the token to be used by the picker and download method
        this.userAccessToken = tokenResponse.access_token;
        // --------------------------

        this.isLoggedIn = true;
        setTimeout(() => {
          this.showPicker = true;
        }, 200); // Wait 500ms
      }
    },
    error_callback: (error: any) => {
      console.error('Google Auth Error:', error);
    }

  });
}

/**
 * Called by a "Sign In" button. This will trigger the Google pop-up.
 */
handleSignIn() {
  if (!this.tokenClient) {
    console.error('Token Client not initialized.');
    return;
  }
  // This triggers the Google OAuth 2.0 consent pop-up
  this.tokenClient.requestAccessToken();
}

handleSignOut() {
  this.userAccessToken = null;
  this.isLoggedIn = false;
}

// --- Picker Logic (From previous answer) ---

onFilePicked(event: any) {
  const file = event.detail.docs[0];
  this.downloadFile(file.id, file.name);
}

onPickerCanceled() {

}

// --- Download Logic (From previous answer) ---

downloadFile(fileId: string, fileName: string) {
  if (!this.userAccessToken) {
    console.error('Cannot download file: no access token.');
    return;
  }

  const url = `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;
  const headers = {
    'Authorization': `Bearer ${this.userAccessToken}`
  };

  this.http.get(url, { headers: headers, responseType: 'blob' })
    .subscribe(blob => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(objectUrl);
    }, error => {
      console.error('Download error:', error);
      // NOTE: If you get a 401 or 403 error here, your token
      // might have expired.
    });
}

// OG-RAG functions

isCreatingOntologies = false

async createOntologiesClientSide() {
  this.isCreatingOntologies = true
  const content = this.posts.filter(post => this.selectedContentKeys.includes(post.key)).filter(post => post.contentType == "post").map((post) => ({key: post.key, content: post.name}))
  const documents: {"key": string, "content": string}[] = this.posts.filter(post => this.selectedContentKeys.includes(post.key)).filter(post => post.contentType == "Document").map((post) => ({key: post.key, content: post.name}))
 await this.ograg.createOntologies(this.userId, this.organizationKey, this.projectKey, content, documents)
 await this.createOntologyEmbeddings(1)
 this.isCreatingOntologies = false
}

async conductReasoning() {
  this.isCreatingOntologies = true
  const content = this.posts.filter(post => this.selectedContentKeys.includes(post.key)).filter(post => post.contentType == "post").map((post) => ({key: post.key, content: post.name}))
  const documents: {"key": string, "content": string}[] = this.posts.filter(post => this.selectedContentKeys.includes(post.key)).filter(post => post.contentType == "Document").map((post) => ({key: post.key, content: post.name}))

  await this.ograg.conductReasoning(this.userId, this.organizationKey, this.projectKey, content, documents)
  this.isCreatingOntologies = false
}

addOrganizationContentTemplateNyKey(templateKey: string) {
  this.firestore.addOrganizationContentTemplateNyKey(this.organizationKey, templateKey)
}

async getOntologies() {
  for (const post of this.posts) {
    if (this.selectedContentKeys.includes(post.key)) {
      const ontologies = await this.firestore.getOntology(this.organizationKey, post.key)
    }
  }
}

async exportOntologiesToFile(minIteration: number, maxIteration: number) {
 this.isCreatingOntologies = true
 // const allOntologies = []; // 1. Collection array

//  for (const post of this.posts) {
   // if (this.selectedContentKeys.includes(post.key)) {
      // Fetch the data
      let ontologies = await this.firestore.getOntologyStatementsByIteration(this.organizationKey, minIteration, maxIteration);
      ontologies = ontologies.map((item: any) => ({
        firstTerm: item.firstTerm,
        secondTerm: item.secondTerm,
        relation: item.relation,
        iteration: item.iteration,
        score: item.score
      }));

      // Add the retrieved data to the collection
      // Assuming 'ontologies' is an array/object you want to save
    /*  allOntologies.push({
        postKey: post.key, // Good to include the key for context
        data: ontologies
      });*/
 //   }
//  }

 /* if (allOntologies.length === 0) {
    console.warn("No ontologies were found for the selected content keys.");
    return;
  }*/

  // 2. Convert the collection to a formatted JSON string
  // The 'null, 2' argument makes the JSON output human-readable (pretty-printed)
  //const jsonString = JSON.stringify(allOntologies, null, 2);

  // 3. Create a Blob (a file-like object) with the JSON content
  const jsonString = JSON.stringify(ontologies, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });

  // 4. Create a download link and click it
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'exported_ontologies.json'; // The name of the downloaded file
  document.body.appendChild(a);
  a.click();

  // Clean up the temporary link and URL object
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  this.isCreatingOntologies = false
}


async createOntologies() {
  this.isCreatingOntologies = true;
  let errorMessage = null;
  let results = null;
  const body = {
    userId: this.userId,
    organizationKey: this.organizationKey,
    projectKey: this.projectKey,
    contentKeys: this.selectedContentKeys,
    documentKeys: this.selectedContentKeys,
    llmLimit: 100,
    maxRows: 200,
    maxLength: 10000,
    launchReasoning: true,
    useCase: "ost"
  }

  this.http.post("https://europe-west1-lessons-learned-fd280.cloudfunctions.net/runCreateOntologies", body).subscribe((response: any) => {
    results = response.ontologies;
    console.log('Ontologies created response: ', results);
    this.isCreatingOntologies = false;
    if (response.status === 'success' && response.ontologies) {
      results = response.ontologies;
    } else {
      errorMessage = response.message || 'Server returned an error.';
      this.isCreatingOntologies = false;
    }
  })

}

async deduce(minIteration: number, maxIteration: number, threshold: number) {
  this.isCreatingOntologies = true
  let i = minIteration
  while (i <= maxIteration) {
    const count = await this.ograg.generateDeduction(this.organizationKey, i, this.userId, threshold)
    console.log("deduction completed for iteration: ", i, "output statements: ", count)
    i += 10
  }
  this.isCreatingOntologies = false
}


  async createOntologyEmbeddings(minimumIteration: number) {
    this.isCreatingOntologies = true
    for (const post of this.posts) {
      if (this.selectedContentKeys.includes(post.key)) {
        let ontologies = await this.firestore.getOntology(this.organizationKey, post.key)
        console.log("ontologies: ",ontologies)
        if (ontologies && ontologies.length > 0) {
          ontologies = ontologies.filter((item: any) => item.iteration >= minimumIteration)
          const maxLength = ontologies.length || 0
          await this.ograg.addOntologyEmbeddings(this.userId, this.organizationKey, this.projectKey, post.key, ontologies, maxLength)
        }
      }
    }
    this.isCreatingOntologies = false
  }

  async createStatements() {
    this.isCreatingOntologies = true
    let statements: any[] = []
    for (const key of this.selectedContentKeys) { 
      statements = await this.ograg.createStatements(this.organizationKey, this.projectKey, this.userId, key)
      console.log("statements: ", statements)
      await this.firestore.addStatements(this.organizationKey, key, statements)
    }
    this.isCreatingOntologies = false
  }

  async deleteOntologyStatementsByIteration(minIteration: number, maxIteration: number) {
    this.isCreatingOntologies = true
    await this.firestore.deleteOntologyStatementsByIteration(this.organizationKey, minIteration, maxIteration)
    this.isCreatingOntologies = false
  }

} 

export interface CreateOntologiesRequest {
  userId: string;
  organizationKey: string;
  projectKey: string;
  contentKeys: string[]; // Keys of content documents
  documentKeys: string[]; // Keys of regular documents
  llmLimit: number;
}

export interface OntologyResult {
  first_term: string;
  second_term: string;
  relation: string;
  iteration: number;
  // ... potentially other properties
}
